module.exports = __webpack_public_path__ + "img/maternity.e1ae2dd1.jpeg";